import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconOne = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1.5,
		y: 2,
		width: 15,
		height: 15,
		rx: 7.5,
		fill: "#5C5C5C"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.2217 6.13672V12.5H8.71875V7.54297H8.68359L7.25098 8.42188V7.12109L8.82422 6.13672H10.2217Z",
		fill: "white"
	})]
});
export default SvgIconOne;
